'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children", "className"];
/**
 * PaginationListItem
 *
 * Renders a pagination's list item.
 */
var PaginationListItem = react.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var styles = react.useStyles();
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.li, _extends__default["default"]({
    className: utils.cx('chakra-pagination-list-item', className),
    __css: styles.listItem
  }, rest), children);
});
PaginationListItem.displayName = 'PaginationListItem';
exports.PaginationListItem = PaginationListItem;